export default "__VITE_ASSET__DTtFzemF__"